import { FadeUp } from "./Reveal";
import { useI18n } from "@/context/Language";

export const WhereMoneyGoes = () => {
  const { t } = useI18n();
  const W = t.where;

  return (
    <section id="where" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <FadeUp className="lg:col-span-5">
            <span className="text-xs uppercase tracking-[0.24em] text-terracotta">{W.overline}</span>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-ink text-balance">{W.heading}</h2>
            <p className="mt-5 max-w-sm text-base leading-relaxed text-ink/70">{W.intro}</p>
          </FadeUp>

          <FadeUp delay={0.15} className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-border-soft border border-border-soft">
              {W.allocations.map((a, i) => (
                <div key={a.title} className="bg-sand p-7">
                  <span className="font-serif text-4xl text-terracotta/30 leading-none">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-4 font-serif text-2xl text-ink">{a.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink/60">{a.note}</p>
                </div>
              ))}
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};

export default WhereMoneyGoes;
